import React, {  useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react"
import { useLocation, useParams, useSearchParams } from "react-router-dom"
import TopBar from "./TopBar/TopBar"
import { Helmet } from 'react-helmet-async';
import logoWhite from '../../image/logo/logoWhite.svg'
import "./RestauScreen.css"
import { contentBlockRestau,typeDailyMenu,typeSchedule,typeSpecialDate,SpaceBlock,ReviewProps,cityWithPreposition, Menu, slugify, contentBannerResto, emptyBannerRestau, contentMenuList, trackRestoTabViewOncePerSession } from "../../components/types/types"
import { Footer } from "../InformationScreen/BarInformationScreen"
import Loading from "../../components/loading/loading"
import { useNavigate } from "react-router-dom";

import { AppContext } from "../../context/AppContext";

import MenuPage from "./NavigationPage/MenuPage";
import ChunkErrorBoundary from "../../components/hook/chunkErrorBoundary";
import { buildSingleRestaurantTypeLabel, feminineClassicTypes } from "../../components/types/restaurantTypes";
const RestaurantPage = React.lazy(() => import("./NavigationPage/RestaurantPage"));
const ReservationPage = React.lazy(() => import("./NavigationPage/ReservationPage"));
const ContainerFiltersResto = React.lazy(() => import("../../components/filter/containerFiltersResto/containerFiltersResto"));
declare global {
    interface Window {
        gtag: (...args: any[]) => void;
    }
}

interface RestauScreenProps {
    listMenuLoad? : contentMenuList[];
    lastUpdateScheduleLoad?: Date,
    listdescLoad?: (contentBlockRestau | SpaceBlock)[],
    headerDescLoad? : [ contentBannerResto,typeSchedule,string,typeSpecialDate],
    listBannerLoad?:contentBannerResto[],
    idrestaurant?:number,
    phoneLoad?:string,
    addressLoad?:[string,string],
    addressHintLoad?:string,
    isResaPhoneLoad?:boolean,
    isResaLinkLoad?:string,
}

interface RestoMeta {
  id: number;
  name: string;
  note: number;
  type: string[];
  cuisines: string[];
  filters: string[];
  devanture: string;
  nbrReview: number;
  visibleCity: string;
  priceRange?: [number, number];
  googlePlaceId?: string;
}
const prefetchCache = new Set<number>();

const prefetchPage = (pageTarget: number) => {
  if (prefetchCache.has(pageTarget)) return;
  prefetchCache.add(pageTarget);

  if (pageTarget === 1) {
    import(/* webpackPrefetch: true */ "./NavigationPage/ReservationPage");
  } else if (pageTarget === 3) {
    import(/* webpackPrefetch: true */ "./NavigationPage/RestaurantPage");
  }
};
const parsePriceRange = (value?: string): [number, number] | undefined => {
    if (!value) return;
    const match = value.match(/\[(\d+(?:\.\d+)?),(\d+(?:\.\d+)?)\]/);
    return match ? [Number(match[1]), Number(match[2])] : undefined;
};
const RestauScreen:React.FC<RestauScreenProps> = ({idrestaurant,listMenuLoad=[],listdescLoad=[],listBannerLoad=[],headerDescLoad=[emptyBannerRestau[0],{},'',{}],phoneLoad,addressLoad,addressHintLoad,lastUpdateScheduleLoad,isResaPhoneLoad,isResaLinkLoad}) => {
    const {loadPage,setLoadPage} = useContext(AppContext)
    const [restoMeta, setRestoMeta] = useState<RestoMeta | null>(null);
    const idR         = restoMeta?.id           ?? idrestaurant ?? -1;
    const restoName   = restoMeta?.name         ?? "";
    const noteR       = restoMeta?.note         ?? 0;
    const typeResto   = restoMeta?.type         ?? [];
    const cuisinesResto = restoMeta?.cuisines   ?? [];
    const filtersResto  = restoMeta?.filters    ?? [];
    const devantureResto = restoMeta?.devanture ?? "";
    const visibleCityVar = restoMeta?.visibleCity ?? "";
    const nbrReviewLoad = restoMeta?.nbrReview ?? 0;
    const getPageFromSearch = (searchParams: URLSearchParams): 1 | 2 | 3 => {
        const pageParam = searchParams.get("section");
        if (pageParam === "reservation") return 1;
        if (pageParam === "restaurant") return 3;
        return 2;
    };
    const navigate = useNavigate();
    const { slugWithId } = useParams();
    const [idUrl, setIdUrl] = useState("");

    const [listMenu,setListMenu] = useState<contentMenuList[]>(listMenuLoad)

    const [restaurantJson,setRestaurantJson] = useState({})
    const WHITELIST = ['Crêperie','Pizzeria','Restaurant à Volonté','Guinguette','Restaurant Ouvrier'];
    const [descSeo,setDescSeo] = useState(`Menu, photos, prix, horaires, avis, adresse : toutes les infos de ce restaurant sont sur QuelResto.`)
    const location = useLocation();
    const [canonicalUrl, setCanonicalUrl] = useState<string>(typeof window !== 'undefined'
        ? `${window.location.origin}${location.pathname}`
        : '');

    const [search] = useSearchParams();

    const [isResaLink,setIsResaLink] = useState(isResaLinkLoad ?? '')
    const [isResaPhone,setIsResaPhone] = useState(isResaPhoneLoad ?? false)

    const [scheduleLoad,setScheduleLoad] = useState(false)
    const [lastUpdateSchedule,setLastUpdateSchedule] = useState<Date>(lastUpdateScheduleLoad || new Date())
    const [schedule,setSchedule] = useState<typeSchedule>(headerDescLoad[1])
    const [special_date,setSpecialDale] = useState<typeSpecialDate>(headerDescLoad[3])
    const [phoneResto,setPhoneResto] = useState(phoneLoad ? phoneLoad : '')
    const [addressResto,setAddressResto] = useState<[string,string]>(addressLoad ? addressLoad : ['',''])
    const [addressHintResto,setAddresHintResto] = useState(addressHintLoad ? addressHintLoad : '')
    const [dailyMenu,setDailyMenu] = useState<typeDailyMenu>({image:'',dates:[],name:'Menu du jour',display_order:0,visible:false})
    const [listDesc,setListDesc] = useState< (contentBlockRestau | SpaceBlock)[]>(listdescLoad)
    const [listBannerResto,setListBannerResto] = useState(listBannerLoad ? listBannerLoad : [])
    const [headerDesc,setHeaderDesc] = useState< [contentBannerResto,typeSchedule,string,typeSpecialDate]>(headerDescLoad)
    const [dateUpdate,setDateUpdate] = useState<Date>(new Date())
    const [listReview,setListReview] = useState<ReviewProps[]>([])
    const [reviewLoad,setReviewLoad] = useState<boolean>(false)
    const [photoRestaurateur,setPhotoRestaurateur] = useState('')
    const [page, setPage] = useState<number>(() => getPageFromSearch(search))
    
    const changeTab = (nextPage: number) => {
        const nextParams = new URLSearchParams(search);
        nextParams.delete("src");
        nextParams.delete("intent");
        if (nextPage === 2) nextParams.delete("section");
        else nextParams.set("section", nextPage === 1 ? "reservation" : "restaurant");
        navigate({pathname: location.pathname,search: nextParams.toString() ? `?${nextParams.toString()}` : ""},{ replace: true });
        setPage(nextPage);
    };
    useEffect(() => {
        const nextPage = getPageFromSearch(search);
        setPage(prev => (prev !== nextPage ? nextPage : prev));
    }, [search]);
    const mainCorpRef = useRef<HTMLDivElement>(null);
    const [ipadViewport, setIpadViewport] = useState({top: 0,bottom: 0});
    useEffect(() => {
    const isTablet =
        window.matchMedia("(pointer: coarse)").matches &&
        window.innerWidth >= 461;

    if (!isTablet) return;

    const vv = window.visualViewport;
    if (!vv) return;

    let rafBottom: number | null = null;
    let topTimer: number | null = null;
    const updateTop = () => {
        const top = Math.min(
            80,
            Math.max(0, Math.round(vv.offsetTop))
        );

        setIpadViewport(prev => {
            if (prev.top === top) return prev;

            return {
                ...prev,
                top
            };
        });
    };

    const scheduleTopUpdate = () => {
        if (topTimer !== null) {
            clearTimeout(topTimer);
        }

        topTimer = window.setTimeout(() => {
            topTimer = null;
            updateTop();
        }, 60);
    };

    const updateBottom = () => {
        if (rafBottom !== null) return;

        rafBottom = requestAnimationFrame(() => {
            rafBottom = null;

            const bottom = Math.max(
                0,
                Math.round(
                    document.documentElement.clientHeight -
                    vv.height -
                    vv.offsetTop
                )
            );

            setIpadViewport(prev => {
                if (prev.bottom === bottom) return prev;

                return {
                    ...prev,
                    bottom
                };
            });
        });
    };

    updateTop();
    updateBottom();

    
    vv.addEventListener("resize", updateTop);
    vv.addEventListener("resize", updateBottom);

    vv.addEventListener("scroll", scheduleTopUpdate);
    vv.addEventListener("scroll", updateBottom);

    return () => {
         vv.removeEventListener("resize", updateTop);
        vv.removeEventListener("resize", updateBottom);

        vv.removeEventListener("scroll", scheduleTopUpdate);
        vv.removeEventListener("scroll", updateBottom);

        if (topTimer !== null) {
            clearTimeout(topTimer);
        }

        if (rafBottom !== null) {
            cancelAnimationFrame(rafBottom);
        }
    };
}, []);

    useLayoutEffect(() => {
        if (typeof window === "undefined" || window.scrollY <= 5) return;
        window.scrollTo(0, 0);
    }, [page]);

    const [showFilters,setShowFilters] = useState(false)
    useEffect(() => {
        const skipSplash = search.get("src") === "home";
        setLoadPage(skipSplash);
        setTimeout(() => {
            setLoadPage(true)
        },2300)
        const url = new URL(window.location.href);
        if (url.searchParams.has('src')) {
            url.searchParams.delete('src');
            window.history.replaceState({}, '', url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash);
        }
    },[])
   useEffect(() => {
        if (!slugWithId) return;
        const parts = slugWithId.split("_");
        const idCandidate = parts[1]; 
        setIdUrl(idCandidate);
        if (idCandidate) {
            const fetchAction = async () => {
                try {
                    await fetchInfo(idCandidate,!listMenuLoad.length)
                } catch (error) {
                    console.error('Erreur de décodage:', error);
                }
            }
            fetchAction();
        }
        
    }, [slugWithId]);
    const [isPublishedResto,setIsPublishedResto] = useState(false)
    useEffect(() => {
        if (!Number.isFinite(idR) || idR <= 0 || !isPublishedResto) return;
        if (page === 3) trackRestoTabViewOncePerSession({restaurantId: idR,tabName: "restaurant"});
        if (page === 2) trackRestoTabViewOncePerSession({restaurantId: idR,tabName: "menu"});
        if (page === 1) trackRestoTabViewOncePerSession({restaurantId: idR,tabName: "reservation"});
    }, [page, idR, isPublishedResto]);
    // const lastTrackedPathRef = useRef<string | null>(null);
    const fetchInfo = async (idUrl:string,shouldMenu:boolean) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getInfoPageResto`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id_url: idUrl,shouldMenu }),
            });

            const data = await response.json();
            if (data.success && data.infopage) {
                const isPublished = !!data.infopage.published;
                setIsPublishedResto(isPublished);
                if(!data.infopage.published) {
                    if (!slugWithId) {
                        navigate('/');
                        return;
                    }

                    const parts = slugWithId.split("_");
                    if(parts.length < 2 ) navigate('/');
                    const idCandidate = parts[1]; 
                    const encoded = parts[2]; 
                     try {
                        const jsonString = atob(encoded); 
                        const decodedData = JSON.parse(jsonString);
                        if(decodedData.id_url !== idCandidate) {
                           navigate('/')
                        }
                    } catch (e) {
                        navigate('/');
                        return;
                    }
                    
                } 
                let priceRange = parsePriceRange( data.infopage.price_range);
                const averagePrice = priceRange ? (priceRange[0] + priceRange[1]) / 2 : undefined;

                let nbrReview = data.infopage.nbr_review
                let note = data.infopage.note
                let name = data.infopage.name

                const prixTxt = priceRange
                ? `prix de ${priceRange[0].toLocaleString("fr-FR")} à ${priceRange[1].toLocaleString("fr-FR")} €/pers`
                : 'prix';

                const noteTxt = (Number(nbrReview) > 0 && Number(note) > 0)
                ? `, ${Number(nbrReview).toLocaleString('fr-FR')} avis, note ${Number(note).toLocaleString('fr-FR',{minimumFractionDigits:1, maximumFractionDigits:1})}/5`
                : '';
                const nextMeta: RestoMeta = {
                    id: data.infopage.idrestaurant,
                    name,
                    note,
                    type: data.infopage.type || [],
                    cuisines: data.infopage.cuisines || [],
                    filters: data.infopage.filters || [],
                    devanture: data.infopage.devanture,
                    nbrReview,
                    visibleCity: data.infopage.visiblecity || "",
                    priceRange,
                    googlePlaceId: data.infopage.google_place_id || undefined,
                };
                const cleanCuisines = Array.isArray(data.infopage.cuisines) ? data.infopage.cuisines
                        .filter((c: unknown): c is string => typeof c === "string" && c.trim() !== "")
                        .map((c: string) => {
                            const clean = c.trim();
                            return clean.includes(":") ? clean.split(":").pop()!.trim() : clean;
                        })
                        .filter(Boolean)
                    : [];
                
                setAddresHintResto(data.infopage.address_hint || '')
                setRestoMeta(nextMeta)
                setListBannerResto(data.infopage.listbanner)
            
                setDescSeo(`Menu, photos, horaires, ${prixTxt}${noteTxt}. Adresse et contact de ${name}.`.replace(',.', '.'))
                setRestaurantJson({
                "@type": "Restaurant",
                "name": name,
                ...(cleanCuisines.length ? { "servesCuisine": [...new Set(cleanCuisines)] } : {}),
                "image": data.infopage.devanture,
                ...(typeof averagePrice === "number"? {"priceRange": averagePrice <= 15? "€": averagePrice <= 30? "€€": averagePrice <= 60? "€€€": "€€€€"}
                : {}),
                ...(data.infopage.google_place_id ? {
                        "identifier": {
                        "@type": "PropertyValue",
                        "propertyID": "google_place_id",
                        "value": data.infopage.google_place_id,
                        },
                    } : {}),
                ...(data.infopage.nbr_review > 0 ? {
                    "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": Number(note),       
                    "reviewCount": Number(nbrReview),
                    "bestRating": 5,
                    "worstRating": 1
                    }
                } : {}),
                 ...(Array.isArray(data.infopage.reviews) && data.infopage.reviews.length > 0 ? {
                        "review": data.infopage.reviews.map((rev: any) => ({
                        "@type": "Review",
                        "reviewRating": {
                            "@type": "Rating",
                            "ratingValue": Number(rev.note),
                            "bestRating": 5,
                            "worstRating": 1,
                        },
                        ...(rev.title ? { "name": rev.title } : {}),
                        "reviewBody": rev.text,
                        "datePublished": rev.post_date,
                        "author": {
                            "@type": "Organization",
                            "name": "QuelResto"
                        }
                        })),
                    }
                    : {}),
                });
            } 
            if (data.success && data.infomenu && shouldMenu) {

                const cityCanonical = (data.infomenu.address?.[1] || "").trim();
                const slugCity = slugify(cityCanonical);
                const nameForCanonical = (data.infopage?.name || data.infomenu?.name || "").trim();
                const slugName = slugify(nameForCanonical);
                const nextCanonical = `${window.location.origin}/restaurant/${slugCity}/${slugName}_${idUrl}`;
                setRestaurantJson(prev => ({
                    ...prev,
                    "@id": `${nextCanonical}#restaurant`,
                    "mainEntityOfPage": { "@id": `${nextCanonical}#webpage` },
                    "url": nextCanonical,
                    address: {
                        "@type": "PostalAddress",
                        "addressLocality": data.infomenu.address[1],
                        "streetAddress": data.infomenu.address[0],
                        "addressCountry": "FR"
                    },
                    "telephone": data.infomenu.phone,
                }));

                setCanonicalUrl(nextCanonical);   
                if(data.infomenu.daily_menu) setDailyMenu(data.infomenu.daily_menu)
                setListMenu(data.infomenu.listmenu || []);
                setAddressResto(data.infomenu.address)
                setPhoneResto(data.infomenu.phone)
                setDateUpdate(data.infomenu.date_update) 
            } 
        } catch (error) {
            console.error("Erreur lors de la connexion :", error);
        }
    }

    const touchStartRef = React.useRef<{x: number; y: number} | null>(null);
    
    const handleSwipeStart = (e: React.TouchEvent<HTMLDivElement>) => {
        const t = e.changedTouches[0];
        touchStartRef.current = { x: t.clientX, y: t.clientY };
    };
    
    const handleSwipeEnd = (e: React.TouchEvent<HTMLDivElement>) => {
        const start = touchStartRef.current;
        if (!start) return;
    
        const t = e.changedTouches[0];
        const deltaX = t.clientX - start.x;
        const deltaY = t.clientY - start.y;

        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 60) {
            const nextPage = deltaX > 0 ? (page  === 3 ? 1 : page  + 1) : (page  === 1 ? 3 : page  - 1)
            changeTab(nextPage);
        }

        touchStartRef.current = null;
    };

    const breadcrumbLd = useMemo(() => {
        const city = addressResto?.[1] || ''; 
        const items = [
            { "@type": "ListItem", "position": 1, "name": "Accueil", "item": "https://www.quelresto.fr/" }
        ];
        if (city) {
            items.push({
            "@type": "ListItem",
            "position": items.length + 1,
            "name": `Restaurants ${cityWithPreposition(city)}`,
            "item": `${window.location.origin}/${slugify(city)}`
            });
        }
        if (restoName) {
            items.push({
            "@type": "ListItem",
            "position": items.length + 1,
            "name": restoName, 
            "item": canonicalUrl
            });
        }
        if (items.length < 2) return null;
        return {
            "@type": "BreadcrumbList",
            "@id": `${canonicalUrl}#breadcrumb`,
            "itemListElement": items
        };
    }, [addressResto?.[1], restoName, canonicalUrl]);


    const webPageLd = useMemo(() => {
        if (!(!!(restoName && addressResto?.[1]))) return null;
        return {
            "@type": "WebPage",
            "@id": `${canonicalUrl}#webpage`,
            "url": canonicalUrl,
            "name": `${restoName} – ${(Array.isArray(typeResto) && typeResto[0] && WHITELIST.includes(typeResto[0]) ? typeResto[0] : 'Restaurant')} ${cityWithPreposition(addressResto[1] || '')} – QuelResto`,
            "description": `Menu, photos, horaires et prix de ${restoName}.`,
            "inLanguage": "fr-FR",
            "isPartOf": { "@id": "https://www.quelresto.fr/#website" },
            "about": { "@id": `${canonicalUrl}#restaurant` },
            "breadcrumb": { "@id": `${canonicalUrl}#breadcrumb` }
        };
    }, [restoName, addressResto]);
    const memoJsonLd = useMemo(() => JSON.stringify({
    "@context": "https://schema.org",
    "@graph": [restaurantJson, webPageLd, breadcrumbLd]
    }), [restaurantJson,webPageLd,breadcrumbLd]);


    const [footerFilters,setFooterFilters] = useState<string[]>([])
    const seoPriorityFilters =  ["Terrasse extérieure","Vue exceptionnelle","Chèque-vacances","Végétarien","Végan","Halal","Parking gratuit","Accès PMR","En couple","En famille avec enfants","Bord de l’eau","Privatisable","Sans gluten","Terrasse couverte","Entre amis",];

    useEffect(() => {
        function getFooterFilters(restoFilters: string[]): string[] {
            const final: string[] = [];
            for (const f of seoPriorityFilters) {
                if (restoFilters.includes(f)) {
                final.push(f);
                if (final.length >= 7) return final;
                }
            }
            for (const f of restoFilters) {
                if (!final.includes(f)) {
                final.push(f);
                if (final.length >= 7) return final;
                }
            }
            return final;
        }
        if(filtersResto && filtersResto.length && filtersResto.length > 0 ) setFooterFilters(getFooterFilters(filtersResto))
    },[filtersResto])

    const showCities:string = useMemo(()=> { return (visibleCityVar && visibleCityVar !== addressResto[1]) ? ` ${cityWithPreposition(visibleCityVar)} (${addressResto[1]})` : cityWithPreposition(addressResto[1])},[addressResto,visibleCityVar])
    const isMasculin = (type:any) => {
        if(type && typeof type === 'string' && type !== '') {
            if(feminineClassicTypes.includes(type)) return false
            else return true
        } else return true
    }
    const cleanCuisinesResto = useMemo(() => {
        if (!Array.isArray(cuisinesResto)) return [];
        return [...new Set(
            cuisinesResto
                .filter((c): c is string => typeof c === "string" && c.trim() !== "")
                .map((c: string) => {
                    const clean = c.trim();
                    return clean.includes(":") ? clean.split(":").pop()!.trim() : clean;
                })
                .filter(Boolean)
        )];
    }, [cuisinesResto]);
    return (
        <>
        {restoName && 

         <Helmet>
            <title>{`${restoName} – ${(Array.isArray(typeResto) && typeResto[0] && WHITELIST.includes(typeResto[0]) ? typeResto[0] : 'Restaurant')} ${cityWithPreposition(addressResto[1] || '')} – QuelResto`}</title>
            <meta
            name="description"
            content={descSeo}
            />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:image" content={devantureResto} />

            <meta property="og:title" content={`${restoName} – ${(Array.isArray(typeResto) && typeResto[0] && WHITELIST.includes(typeResto[0]) ? typeResto[0] : 'Restaurant')} ${cityWithPreposition(addressResto[1] || '')} – QuelResto`} />
            <meta property="og:description" content={descSeo} />
            <meta property="og:image" content={devantureResto} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={canonicalUrl} />
            <link rel="canonical" href={canonicalUrl} />
            <script type="application/ld+json">{memoJsonLd}</script>
        </Helmet> }

        <div className="restauScreen primaryBack" id="restauScreen" style={{
        "--ipad-top-offset": `${ipadViewport.top}px`,
        "--ipad-bottom-offset": `${ipadViewport.bottom}px`
    } as React.CSSProperties}>
            {!loadPage && <div className='loadPage'>
                <div className="containerMove">
                    <img  src={logoWhite} loading="eager" decoding="async" alt="QuelResto"   width={433} height={129}/>
                    <span className="loadPageSubtitle XsmallText">Entreprise <strong>Angevine</strong></span>
                </div>
                <div className="mask"></div>
            </div>}
            <div className="mainCorp" style={{zIndex:1}} ref={mainCorpRef}> 
                <TopBar name={restoName} page={page} setPage={changeTab} />
                
                {page === 2 ? <div className="menuShell">
                    {listMenu.length === 0 && <div className="menuNotLoad pageMenu primaryBack"><Loading /></div> }
                    <MenuPage listMenu={listMenu} photoRestaurateur={photoRestaurateur} setPhotoRestaurateur={setPhotoRestaurateur} nbrReviewLoad={nbrReviewLoad} setReviewLoad={setReviewLoad} reviewLoad={reviewLoad} listReview={listReview}  setListReview={setListReview} dateUpdate={dateUpdate}  idRestaurant={idR} note={noteR} dailyMenu={dailyMenu}/>
                </div>
                : <ChunkErrorBoundary><React.Suspense fallback={<div className="menuNotLoad"><Loading /></div>}>
                    {     
                        page === 1 ?
                        <ReservationPage address_hint={addressHintResto} lastUpdateSchedule={lastUpdateSchedule} id_url={idUrl} nameResto={restoName} scheduleLoad={scheduleLoad} setScheduleLoad={setScheduleLoad}  schedule={schedule} special_date={special_date} setLastUpdateSchedule={setLastUpdateSchedule} setSchedule={setSchedule} setSpecialDate={setSpecialDale} phone={phoneResto} address={addressResto} idrestaurant={idR} 
                            isResaLink={isResaLink} isResaPhone={isResaPhone} setIsResaLink={setIsResaLink} setIsResaPhone={setIsResaPhone}/>
                        :  <RestaurantPage address_hint={addressHintResto} isResaPhone={isResaPhone} setIsResaPhone={setIsResaPhone} lastUpdateSchedule={lastUpdateSchedule} id_url={idUrl} nameResto={restoName} setHeaderDesc={setHeaderDesc} setLastUpdateSchedule={setLastUpdateSchedule} setListBanner={setListBannerResto} setListDesc={setListDesc} headerDesc={headerDesc} listBanner={listBannerResto} type={typeResto} cuisines={cuisinesResto} listFilters={filtersResto} description={listDesc} idResto={idR} phone={phoneResto} address={addressResto} />
                    }
                </React.Suspense></ChunkErrorBoundary>
                }
                {showFilters && <React.Suspense fallback={null}>
                    <ContainerFiltersResto type={typeResto} cuisines={cuisinesResto} listFilters={filtersResto} setShowFilters={setShowFilters}/> </React.Suspense>}
                <div className="secondaryBack largeText infoBottom"> 
                    <div className="separationInfo"></div>
                    <h2 className="titleDesc secondaryBack largeTitle" style={{marginBottom: '10px'}}>{typeResto && buildSingleRestaurantTypeLabel(typeResto[0])} {showCities} – menu, carte, photos, avis, horaires et prix.</h2>
                    <h3 className="titleScndDesc secondaryBack largeTitle text">{restoName} - QuelResto</h3>
                    <p className="text XsmallText">{restoName} est {isMasculin(typeResto[0] || '') ? ' un ' : ' une '} {(typeResto && typeResto[0]) ? `${buildSingleRestaurantTypeLabel(typeResto[0]).toLowerCase()} ` : ' restaurant '} {showCities}. {isMasculin(typeResto[0] || '') ? ' Il ' : ' Elle '} propose une cuisine {cleanCuisinesResto && cleanCuisinesResto.length > 0 && cleanCuisinesResto[0] ? `${cleanCuisinesResto[0].toLowerCase()}${cleanCuisinesResto.length > 1 && cleanCuisinesResto[1] ? ` et ${cleanCuisinesResto[1].toLowerCase()}, ` : ', '}`  : ''} avec un prix moyen compris entre {restoMeta?.priceRange?.[0]}&nbsp;€ et {restoMeta?.priceRange?.[1]}&nbsp;€ par personne.</p>
                    {(footerFilters && footerFilters.length) ? <div className="text XsmallText listFilters">
                        <span className="nameListFilters">Voici quelques filtres renseignés par le restaurant :&nbsp;</span>
                        {footerFilters.map((elem,id) => {
                            return <React.Fragment key={'elemFiltersFooter'+id}><span className="elemFilter" style={{fontStyle:'italic'}}>{elem}</span>
                                {id < footerFilters.length-1 ? `,\u00A0` : ''}
                                {id === footerFilters.length-1 ? '.' : ''}
                            </React.Fragment>
                        })}
                        <span className="moreFilters pointer" onClick={() => setShowFilters(true)}>Voir tous les filtres du restaurant</span>
                    </div> : <></>}
                    <p className="text XsmallText">Les horaires et la carte sont régulièrement actualisés, avec leur date de mise à jour affichée. Les avis clients indiquent toujours la date de publication, pour vous garantir des informations fiables et récentes.</p>
                    <p className="text XsmallText discover">Découvrez aussi &nbsp;<a href={`${window.location.origin}/${slugify(addressResto[1])}`} target="_blank">Les bons restaurants {cityWithPreposition(addressResto[1])}</a>&nbsp; pour explorer d’autres adresses à proximité !</p>
                </div>
                <Footer isResto={true}/>
                <div className="espacmentPhone"></div>
                <div
                    className="menuTel primaryBack"
                    onTouchStart={handleSwipeStart}
                    onTouchEnd={handleSwipeEnd}
                >
                    
                    <div className="containerPart"><h2 className={`pointer part ${page === 3 ? 'smallTitleBold' : 'smallTitle'}`} onTouchStart={() => prefetchPage(3)} onClick={() => changeTab(3)}>
                        Restaurant
                        {page === 3 && <div></div>}
                    </h2></div>
                    <div className="containerPart"><h2 className={`pointer part ${page === 2 ? 'smallTitleBold' : 'smallTitle'}`} onClick={() => changeTab(2)}>
                        Menu
                        {page === 2 && <div></div>}
                    </h2></div>
                    <div className="containerPart"><h2 className={`pointer part ${page === 1 ? 'smallTitleBold' : 'smallTitle'}`} onTouchStart={() => prefetchPage(1)} onClick={() => changeTab(1)}>
                        Réservation
                        {page === 1 && <div></div>}
                    </h2></div>
                </div>

 
            </div>
        </div>
        </>
    )
}

export default RestauScreen
